import React from 'react'
import AppBackBtn from '../components/ui/AppBackBtn'
import AppWrapper from '../components/ui/AppWrapper/AppWrapper'

const RefundView: React.FC = () => {
  return (
    <>
      <AppBackBtn to="/home" />
      <AppWrapper className="bg-appLightGray h-[80%] gap-y-2">
        <p className="font-semibold text-black text-base">Возврат</p>
        <p className="text-[14px]">
          По вопросам возврата свяжитесь с нами по следующему номеру телефона: +7 917 247 6789
        </p>
        <p className="text-[14px]">
          Срок рассмотрения заявки на возврат денежных средств составляет 14 дней. Возврат денежных
          средств осуществляется на ту же банковскую карту, с которой производился платеж. Возврат
          денежных средств на карту осуществляется в срок от 5 до 30 банковских дней, в зависимости
          от Банка, которым была выпущена банковская карта.
        </p>
      </AppWrapper>
    </>
  )
}

export default RefundView
